import { useState } from 'react'
import { Dropdown } from 'primereact/dropdown'
import './LocationDropdown.scss'
import { useTranslation } from 'react-i18next'

const LocationDropdownMenu = (props: {
  selectedLocation: any
  setSelectedLocation: any
  selectedCompany: any
  locationList: any
  userInfo: any
  firmList: any[]
  onFocus: any
  getData: any
}) => {
  const [panelIsOpen, setPanelIsOpen] = useState(false)
  const { t } = useTranslation()
  const onShow = () => {
    setPanelIsOpen(true)
  }
  const onHide = () => {
    setPanelIsOpen(false)
  }

  return (
    <div className="locationdropdown">
      <div style={{ position: 'relative' }}>
        <Dropdown
          value={props.selectedLocation}
          disabled={
            props.selectedCompany?.name === `(${t('input-texts.all-firms')})` ||
            props.locationList.length === 0 ||
            props.locationList.length === 1
          }
          options={
            props.userInfo !== 'LocationAdmin' || props.firmList.length > 1
              ? [{ id: null, name: `(${t('input-texts.all-locations')})` }, ...props.locationList]
              : [...props.locationList]
          }
          style={{ maxWidth: '200px' }}
          className="location-dropdown"
          optionLabel="name"
          scrollHeight="200px"
          onChange={(e) => {
            props.setSelectedLocation(e.target.value)
            props.getData(props.selectedCompany, e.target.value)
          }}
          onShow={onShow}
          onHide={onHide}
          onFocus={props.onFocus}
          dropdownIcon={panelIsOpen ? 'pi pi-chevron-up' : 'pi pi-chevron-down'}
        />
      </div>
    </div>
  )
}

export default LocationDropdownMenu
